import {createContext} from 'react';

import {VehicleSeriesDefinitionContextType} from '../utils/types';

export const VehicleSeriesDefinitionFormContext = createContext<VehicleSeriesDefinitionContextType>(
  {
    branchList: [],
    seriesList: [],
    vehicleTypes: [],
  }
);
